/* eslint-disable multiline-ternary */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { Checkbox, Flex } from '@chakra-ui/react'

interface iProps {
  isChecked?: boolean
  OnChange: (e: boolean) => void
  minW?: string
  fontSize?: string
  isDisabled?: boolean
  styles?: any
  readonly?: boolean
  my?: string
  whiteTheme?: boolean
  onBlur?: () => void
}

export const CheckboxCmp: React.FC<iProps> = ({ styles, isChecked, OnChange, minW, children, isDisabled, fontSize, readonly, my, whiteTheme, onBlur }) => {
  return (
    <Checkbox
      isDisabled={isDisabled}
      borderColor={'var(--Gray4)'}
      size={'md'}
      isChecked={isChecked}
      spacing={'.5rem'}
      style={styles}
      isReadOnly={readonly}
      my={my}
      iconColor={whiteTheme ? 'black' : undefined}
      sx={whiteTheme ? {
        '& .chakra-checkbox__control': {
          bg: 'white',
          borderColor: 'var(--Gray4)',
          _hover: {
            bg: 'var(--c2) !important',
            borderColor: 'var(--Gray3)'
          }
        },
        '& .chakra-checkbox__control[data-checked]': {
          bg: 'white',
          borderColor: 'white'
        }
      } : undefined}
      onChange={(e) => OnChange(e.target.checked)}
      onBlur={onBlur}
    ><Flex lineHeight={'1rem'} fontSize={fontSize ?? '.875rem'} minW={minW}>{children}</Flex></Checkbox>
  )
}
